import "./Protocols.module.css";
import Cabecalho from "@/reusable_sections/Header";
import EspecialidadesClinicas from "./sections/EspecialidadesClinicas";
import FaqSection from "./sections/FaqSection";
import Rodape from "@/reusable_sections/Footer";
export default function ProtocolsPage() {
  return <div>
      <Cabecalho />
      <EspecialidadesClinicas />
      <FaqSection />
      <Rodape />
    </div>;
}